import styled from "styled-components";

export const SliderWrapper = styled.div`
    width: min(96%, 1600px);
    margin: 24px auto 0;
    border-radius: var(--radius-xl);
    overflow: hidden;
    box-shadow: var(--shadow-md);

    @media (max-width: 900px) {
        width: 100%;
        margin: 0;
        border-radius: 0;
        box-shadow: none;
    }

    .swiper-button-next,
    .swiper-button-prev {
        color: white;
        background: rgba(0, 0, 0, 0.32);
        width: 44px;
        height: 44px;
        border-radius: 50%;
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
        transition: var(--transition);

        &::after {
            font-size: 16px;
            font-weight: 800;
        }

        &:hover {
            background: var(--color-primary);
        }

        @media (max-width: 600px) {
            display: none;
        }
    }
`;

export const SliderBlock = styled.div`
  max-width: 1920px;
  width: 100%;
  height: clamp(380px, 56vw, 620px);
  display: flex;
  position: relative;

  @media (max-width: 900px) {
    height: clamp(320px, 78vw, 460px);
  }

  @media (max-width: 600px) {
    height: clamp(300px, 92vw, 420px);
  }
`;

export const SliderImg = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.1) 60%, rgba(0, 0, 0, 0) 100%);
    pointer-events: none;
  }

  @media (max-width: 600px) {
    &::after {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.55) 65%, rgba(0, 0, 0, 0.75) 100%);
    }
  }
`;

export const UpBlock = styled.div`
  position: absolute;
  top: 50%;
  left: clamp(24px, 8%, 140px);
  transform: translateY(-50%);
  z-index: 2;
  max-width: 720px;

  a {
    text-decoration: none;
  }

  @media (max-width: 600px) {
    top: auto;
    bottom: 22px;
    left: 16px;
    right: 16px;
    transform: none;
    max-width: 100%;
  }
`;

export const UpTextBlock = styled.div`
  background: rgba(15, 25, 5, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  width: fit-content;
  max-width: 100%;
  font-weight: 600;
  line-height: 1.35;
  font-size: clamp(20px, 2.4vw, 38px);
  color: white;
  padding: 22px 28px;
  border-radius: var(--radius-lg);
  border-left: 4px solid var(--color-primary);

  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 1.45;
    padding: 14px 16px;
    border-radius: var(--radius-md);
    border-left-width: 3px;
    background: rgba(15, 25, 5, 0.62);
    width: 100%;
    box-sizing: border-box;
  }
`;

export const UpBlockButton = styled.div`
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: var(--color-primary);
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
  cursor: pointer;
  border-radius: var(--radius-md);
  box-shadow: 0 10px 24px rgba(91, 139, 15, 0.4);
  transition: var(--transition);

  &:hover {
    background: var(--color-primary-dark);
    transform: translateY(-2px);
    box-shadow: 0 14px 30px rgba(91, 139, 15, 0.5);
  }

  @media (max-width: 600px) {
    padding: 11px 22px;
    font-size: 13px;
    margin-top: 12px;
    box-shadow: 0 6px 14px rgba(91, 139, 15, 0.4);
  }
`;
